import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const ir = {
    jpath: ['spectra', 'ir'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default ir;
//# sourceMappingURL=ir.js.map